import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AspProductDetailsService } from '../asp-product-details/asp-product-details.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AspClutchKitDetailsService } from './asp-clutch-kit-details.service';
import { MatDialog } from '@angular/material/dialog';
import { AspConfirmOrderPopupComponent } from '../asp-confirm-order-popup/asp-confirm-order-popup.component';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-asp-clutch-kit-details',
  templateUrl: './asp-clutch-kit-details.component.html',
  styleUrls: ['./asp-clutch-kit-details.component.scss']
})
export class AspClutchKitDetailsComponent implements OnInit {

  type: string;
  id: string;
  totalPrice: number = 0;
  showPopup = false;
  defaultImage: string = 'assets/images/logos/logo.png';
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  assignedWarehouseStock = 0;
  hasStockInAssigned: boolean = false;
  hasStockInOther: boolean = false;
  noStockAnywhere: boolean = false;
  isSingleKit: boolean = false;
  isSplitKit: boolean = false;
  isFullKit: boolean = false;
  compatability: any[] = [];
  selectedKitType = '';
  activeItem: any;
  showAllMap: { [key: string]: boolean } = {};
  vehicles: any[] = [];
  isMobile: boolean = false;
  clutchList: any[] = [];
  showEmptyState: boolean = false;
  orderCreateData: any;
  warehouseStock: any[] = [];
  assignedWarehouseName: string = '';
  selectedItem: any;
  showFloatingBtn = false;
  pricingSummary: any = {};
  selectedImage: string = '';
  noPartsNames: string[] = [];
  isPopupOpen: boolean = false;
  response: any;
  spareRequestId: string = '';
  vehicleData: any;
  existingRequestId: string = '';
  updatePopupData: any = {};
  existingRequest: any;
  brandText: string = '';
  partNumberText: string = '';
  partTypeText: string = '';
  isRequestExistsPopupOpen: boolean = false;
  reCreateRequest: boolean = false;
  oesParts: any[] = [];
  oemParts: any[] = [];
  oemItem: any = null;
  oesItem: any = null;
  showOemOesDiv: boolean;
  summaryTitle: string = '';
  selectedPricingSummary: any = {};
  filteredClutchList: any[] = [];
  oesBrands = '';
  oemBrands = '';
  constructor(
    private route: ActivatedRoute,
     private router: Router,
    private clutchKitService: AspClutchKitDetailsService,
    private aspLoadingService: AspLoadingService,
    private aspProductDetailsService: AspProductDetailsService,
    private dialog: MatDialog,
    public toastr: ToastrService,
    private cd: ChangeDetectorRef
  ) {}
  @ViewChild('productSection') productSection: ElementRef;
  @ViewChild('stickyBtn') stickyBtn!: ElementRef;

  ngOnInit(): void {
    const savedVehicle = localStorage.getItem('vehicleData');
    if (savedVehicle) {
      this.vehicleData = JSON.parse(savedVehicle);
    }
    // console.log("vehicleData in clutch:", this.vehicleData);
    // console.log("Restored vehicleData:", this.vehicleData);
     const isClutchFlow = localStorage.getItem('clutchFlow');
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.id = params.get('id');
    });

    // console.log("🚀 Clutch Page Loaded");
    // console.log("Route Params:", { type: this.type, id: this.id });

    this.getClutchKitDetails();
  }
  @HostListener('window:scroll', [])
    onWindowScroll() {
      this.onScroll();
    }
    ngAfterViewInit() {
      setTimeout(() => {
        this.onScroll(); // 👈 initial check
      }, 100);
    }

  getClutchKitDetails() {

    const garageKey = localStorage.getItem('garageKey');
    const regNo = localStorage.getItem('registrationNumber');

    // console.log('📦 API Inputs:', { garageKey, regNo });

    this.aspLoadingService.show();

    const manualVariantKey = localStorage.getItem('variantKey');
    const isManualFlow = localStorage.getItem('clutchFlow') === '1';

    const variantToSend = (isManualFlow && manualVariantKey) 
      ? manualVariantKey 
      : this.vehicleData?.variantKey;
      this.clutchKitService
      .getClutchSuggestions(3, variantToSend, 'String', garageKey, regNo)
      .subscribe(
        (res: any) => {

          // console.log('🔥 FULL API RESPONSE:', res);
          this.pricingSummary = res?.data?.pricingSummary || {};
          const mapData = res?.data?.map;
          this.orderCreateData = res?.data?.orderCreate;

          // ✅ HANDLE "NO PARTS FOUND"
          if (res?.code === 111 || res?.message === 'No parts found') {

            console.warn('❌ No parts found → waiting for button click');

            this.aspLoadingService.hide();
            this.hitFailureAPI();
            this.showEmptyState = true;

            // ✅ FIXED: correct path
            this.noPartsNames = res?.data?.partNames || [];

            // console.log('📦 Stored part names:', this.noPartsNames);

            return;
          }

          // ✅ SUCCESS CASE
          if (res?.code === 200 && mapData && Object.keys(mapData).length > 0) {
            this.aspLoadingService.hide();

            // ✅ REMOVE FLAG AFTER SUCCESS
            if (isManualFlow) {
              localStorage.removeItem('clutchFlow');
            }
          }
          // ⚠️ ONLY retry for TEMPORARY cases (optional)
          else {
            console.warn('⏳ Temporary issue → retrying...');
            setTimeout(() => {
              this.getClutchKitDetails();
            }, 3000);
          }

          // const mapData = res?.data?.map;
          this.orderCreateData = res?.data?.orderCreate;

          if (mapData && Object.keys(mapData).length > 0) {

            let rawList: any[] = [];
            Object.keys(mapData).forEach(key => {
              const items = mapData[key] || [];
              rawList = [...rawList, ...items];
            });

            // console.log('📦 Raw List:', rawList);

            // ✅ MAP DATA
            this.clutchList = rawList.map(item => {
            
              const partInfo = item?.partInfo || {};
              const warehouse = item?.warehouseInfo?.[0]?.warehouses?.[0] || {}; // ✅ FIXED
              const zoho = item?.zohoPartPrice?.[0] || {};
              let images: string[] = [];
              if (partInfo?.productImageUrl) {
                images.push(partInfo.productImageUrl + '?v=' + new Date().getTime());
              } else {
                images.push(this.defaultImage);
              }
              let mrp = null;
              let sellingPrice = null;
              let saveAmount = null;
              let discount = null;

              if (zoho?.rate) {
                mrp = zoho.rate;
                discount = zoho?.discount || 0;
                sellingPrice = mrp - (mrp * discount / 100);
                saveAmount = mrp * discount / 100;
              } else if (partInfo?.mrp) {
                mrp = partInfo.mrp / 100;
                sellingPrice = mrp;
                saveAmount = 0;
                discount = null;
              }

              return {
                partName: partInfo?.partName || null,
                partNumber: partInfo?.partNumber || null,
                brand: partInfo?.brand || null,
                partType: partInfo?.partType || null,
                category: partInfo?.partCategory || null,
                partCategory: partInfo?.partCategory || null,
                partSubCategory: partInfo?.partSubCategory || null,
                sellingPrice,
                mrp,
                discount,
                saveAmount,
                // image: partInfo?.productImageUrl || null,
                image: partInfo?.productImageUrl
                ? partInfo.productImageUrl + '?v=' + new Date().getTime()
                : this.defaultImage,
                warehouseName: warehouse?.warehouse_name || null,
                warehouseId: warehouse?.warehouse_id || null,
                images: images,
                raw: item
              };
            });
            // ✅ OEM / OES DATA
            this.oesItem = {
              title: res?.data?.pricingSummary?.OES?.title || '',
              totalMrp: res?.data?.pricingSummary?.OES?.totalMrp || 0,
              totalSellingPrice: res?.data?.pricingSummary?.OES?.totalSellingPrice || 0,
              discount: res?.data?.pricingSummary?.OES?.discount || 0,
              savings: res?.data?.pricingSummary?.OES?.savings || 0,
              items: this.clutchList.filter(x => x.partType === 'OES')
            };

            this.oemItem = {
              title: res?.data?.pricingSummary?.OEM?.title || '',
              totalMrp: res?.data?.pricingSummary?.OEM?.totalMrp || 0,
              totalSellingPrice: res?.data?.pricingSummary?.OEM?.totalSellingPrice || 0,
              discount: res?.data?.pricingSummary?.OEM?.discount || 0,
              savings: res?.data?.pricingSummary?.OEM?.savings || 0,
              items: this.clutchList.filter(x => x.partType === 'OEM')
            };

            this.oesParts = this.clutchList.filter(
              item => item?.partType === 'OES'
            );

            this.oemParts = this.clutchList.filter(
              item => item?.partType === 'OEM'
            );
            this.oesBrands = [...new Set(this.oesParts.map(item => item.brand))].join(', ');
            this.oemBrands = [...new Set(this.oemParts.map(item => item.brand))].join(', ');
            const hasOEM = this.oemParts.length > 0;
            const hasOES = this.oesParts.length > 0;
            this.showOemOesDiv = hasOEM && hasOES;
            this.summaryTitle =
            res?.data?.pricingSummary?.OEM?.title ||
            res?.data?.pricingSummary?.OES?.title ||
            '';
            this.selectedPricingSummary =
            res?.data?.pricingSummary?.OEM?.title
              ? res?.data?.pricingSummary?.OEM
              : res?.data?.pricingSummary?.OES || {};
            // ✅ DEFAULT SELECTED
            if (this.oesItem?.items?.length) {
              this.selectKit('OES');
            } else if (this.oemItem?.items?.length) {
              this.selectKit('OEM');
            }
            this.setClutchTexts();
            this.selectedImage = this.clutchList[0]?.image || this.defaultImage;
            // console.log('📋 Final Clutch List:', this.clutchList);
            // ✅ FIX: Move bad images (like drivetrain) to last
            this.clutchList.sort((a, b) => {
              const isBadA = a.image?.includes('categories');
              const isBadB = b.image?.includes('categories');

              return Number(isBadA) - Number(isBadB);
            });
            this.activeItem = this.clutchList[0];
            // ✅ COMBINE INTO KIT (ADD HERE)
              // if (this.clutchList.length >= 3) {

              //   const total = this.clutchList.reduce((sum, item) => {
              //     return sum + (item?.sellingPrice || 0);
              //   }, 0);

              //  this.selectedItem = {
              //     partName: 'Clutch Kit (Complete Set)',
              //     brand: this.clutchList[0]?.brand,
              //     partType: this.clutchList[0]?.partType,

              //     partCategory: this.clutchList[0]?.partCategory,

              //     // 🔥 FIX: combine all subcategories
              //     partSubCategory: [...new Set(this.clutchList.map(x => x.partSubCategory))]
              //       .filter(Boolean)
              //       .join(', '),

              //     sellingPrice: total,
              //     mrp: this.clutchList.reduce((sum, item) => sum + (item?.mrp || 0), 0),
              //     saveAmount: this.clutchList.reduce((sum, item) => sum + (item?.saveAmount || 0), 0),
              //     discount: this.pricingSummary?.discount || 0,
              //     items: this.clutchList
              //   };

              //   this.isFullKit = true;
              // } 
             
            // this.selectedItem = this.clutchList[0];
                    if (!this.selectedItem?.image) {
          this.selectedItem.image = this.defaultImage;
        }
            this.totalPrice = this.clutchList.reduce((sum, item) => {
              return sum + (item?.sellingPrice || 0);
            }, 0);

            // 👉 Get all warehouses from response
            const allWarehouses = [];

            this.clutchList.forEach(item => {
              const warehouses = item?.raw?.warehouseInfo?.[0]?.warehouses || [];

              warehouses.forEach(w => {
                const existing = allWarehouses.find(x => x.warehouseId === w.warehouse_id);

                if (existing) {
                  existing.stock += (w.quantity_available_for_sale || 0);
                } else {
                  allWarehouses.push({
                    name: w.warehouse_name,
                    stock: w.quantity_available_for_sale || 0,
                    warehouseId: w.warehouse_id
                  });
                }
              });
            });

            // 👉 Find assigned warehouse (from API)
            const assignedId = this.orderCreateData?.wareHouseId;
            // const assigned = allWarehouses.find( w => String(w.warehouseId) === String(assignedId));
            const assigned = allWarehouses.find(
                w => Number(w.warehouseId) === Number(assignedId)
              );

            // ✅ FINAL VALUES FOR UI
            this.assignedWarehouseStock = assigned?.stock || 0;
            this.assignedWarehouseName = assigned?.name || 'Assigned Warehouse';
            // 👉 Save full list for UI
            this.warehouseStock = allWarehouses;
            // ✅ FIX STOCK FLAGS
            this.hasStockInAssigned = this.assignedWarehouseStock > 0;

            this.hasStockInOther = this.warehouseStock.some(
              w => w.stock > 0 && String(w.warehouseId) !== String(assignedId)
            );

            this.noStockAnywhere =
              !this.hasStockInAssigned && !this.hasStockInOther;
            // console.log('🏬 Warehouse List:', this.warehouseStock);
            // console.log('⭐ Assigned Stock:', this.assignedWarehouseStock);
            // console.log('💰 Total Price:', this.totalPrice);

            const count = this.clutchList.length;
            this.isSingleKit = count === 1;
            this.isFullKit = count > 1;

            //   console.log('🧠 UI Mode:', {
            //     isSingleKit: this.isSingleKit,
            //     isSplitKit: this.isSplitKit,
            //     isFullKit: this.isFullKit
            //   });

            // console.log('🧠 isFullKit:', this.isFullKit);

            // =========================

            const partNumber = this.clutchList[0]?.partNumber;

            if (partNumber) {
              this.getCompatability(partNumber);
            } else {
              console.warn('⚠️ Part number missing');
              this.showEmptyState = true;
            }

          } else {
            console.warn('⚠️ No clutch data found');
            this.showEmptyState = true;
          }
        },
        err => {
          this.aspLoadingService.hide();
          console.error('❌ API ERROR:', err);
          this.showEmptyState = true;
        }
      );
  }

  getCompatability(partNumber: string) {

    // console.log("📡 Calling Compatibility API with:", partNumber);

    this.aspLoadingService.show();

    this.aspProductDetailsService
      .getProductCompatability(partNumber)
      .subscribe(result => {

        let res = JSON.parse(JSON.stringify(result));
        this.aspLoadingService.hide();

        // console.log("🚗 Compatibility API Response:", res);

        this.compatability = [];

        if (!res?.data?.vehicle?.length) {
          console.warn("⚠️ No compatibility data");
          return;
        }

        res.data.vehicle.forEach(vehicle => {

          let data = [];

          vehicle.models.forEach(model => {

            let rowKey = model.rowKey;
            let modelName = model.model;

            res.data.variants[rowKey]?.forEach(list => {
              list.model = modelName;
              data.push(list);
            });

          });

          this.compatability.push([vehicle.name, data]);
          this.showAllMap[vehicle.name] = false;
          this.vehicles = vehicle.models.length;
        });

        // console.log("✅ FINAL Compatibility Data:", this.compatability);
      });
  }

  // =========================
  // UI HELPERS
  // =========================
  getVisibleModels(models: any[], vehicleName: string): any[] {
    return this.showAllMap[vehicleName] ? models : models.slice(0, 10);
  }

  toggleShowMore(vehicleName: string) {
    this.showAllMap[vehicleName] = !this.showAllMap[vehicleName];
  }

  // =========================
  // POPUP
  // =========================
  checkAvailability() {
    this.showPopup = true;
    this.evaluateStock();
  }

  closePopup() {
    this.isPopupOpen = false;
    this.router.navigate(['home']);
  }
  

  // =========================
  // STOCK LOGIC
  // =========================
  evaluateStock() {

    const warehouseStock = this.clutchList?.[0]?.warehouseStock || [];
    const zone = localStorage.getItem("zone") || '';

    let assigned = warehouseStock.find(w => w.name === zone);

    this.assignedWarehouseStock = assigned?.stock || 0;

    this.hasStockInAssigned = this.assignedWarehouseStock > 0;

    this.hasStockInOther = warehouseStock.some(w => w.stock > 0);

    this.noStockAnywhere =
      !this.hasStockInAssigned && !this.hasStockInOther;
  }
 onAddToCart() {

    let orderData = this.orderCreateData || {};

    orderData.garageKey = orderData?.garageKey || localStorage.getItem('garageKey');
    orderData.userKey = orderData?.userKey || localStorage.getItem('spareUserKey');
    orderData.userType = orderData?.userType || localStorage.getItem('userType') || 'garage';

    if (orderData?.data?.length > 0) {

      const item = orderData.data[0];

      item.fuelType = item?.fuelType || localStorage.getItem('fuelType');
      item.make = item?.make || localStorage.getItem('selectedMake');
      item.model = item?.model || localStorage.getItem('selectedModel');
      item.mfgYear = item?.mfgYear || localStorage.getItem('selectedYear');

      item.registrationNumber =
        item?.registrationNumber ||
        localStorage.getItem('registrationNumber');

      item.variantKey = item?.variantKey || localStorage.getItem('variantKey');
      item.rowKey = item?.rowKey || localStorage.getItem('rowKey');
      item.variant = item?.variant || localStorage.getItem('variant');
    }

    // ❌ still no data → stop
    if (!orderData || !orderData.data) {
      console.warn('❌ No order data found');
      this.toastr.error('Order data missing. Please try again');
      return;
    }

    const payload = {
      orderCreate: this.orderCreateData
    };

    this.aspLoadingService.show();

    this.clutchKitService.instantOrder(payload)
      .subscribe(
        (res: any) => {
          this.aspLoadingService.hide();

          // console.log('✅ Order Created:', res);

          if (res?.code === 200) {

          sessionStorage.setItem('order', JSON.stringify(res?.data));

          this.dialog.open(AspConfirmOrderPopupComponent, {
            width: '400px',
            panelClass: 'custom-dialog-container',
            disableClose: true
          });
        } 
         else {
          this.toastr.error(res?.data?.description || 'Something went wrong', 'Error');
        }
        },
        err => {
          this.aspLoadingService.hide();
          console.error('❌ Order API Error:', err);
        }
      );
  }
  onImageError(event: any) {
    event.target.src = this.defaultImage;
    event.target.onerror = null; // 🔥 prevents infinite loop
  }
  selectItem(item: any) {
    this.selectedItem = item;
  }
  selectImage(item: any) {
    this.selectedImage = item.image || this.defaultImage;
     this.activeItem = item;
    
  }
  onScroll() {
    if (!this.stickyBtn) return;

    const rect = this.stickyBtn.nativeElement.getBoundingClientRect();

    const isVisible =
      rect.top >= 0 && rect.bottom <= window.innerHeight;

    this.showFloatingBtn = !isVisible;
  }
 createClutchRequest() {

  // ✅ STEP 0: Restore vehicleData (THIS IS YOUR FIX)
  if (!this.vehicleData || !this.vehicleData.variantKey) {
    this.vehicleData = {
      make: localStorage.getItem('selectedMake') || '',
      model: localStorage.getItem('selectedModel') || '',
      variant: localStorage.getItem('variant') || '',
      year: localStorage.getItem('selectedYear') || '',
      fuel: localStorage.getItem('fuelType') || '',
      variantKey: localStorage.getItem('variantKey') || '',
      rowKey: localStorage.getItem('rowKey') || '',
      registrationNumber: localStorage.getItem('registrationNumber') || ''
    };
  }

  // console.log('🚗 vehicleData AFTER restore:', this.vehicleData);

  // ✅ STEP 1: Validate parts
  if (!this.noPartsNames || this.noPartsNames.length === 0) {
    this.toastr.error('No parts available to create request');
    return;
  }

  // ✅ STEP 2: Validate vehicle data
  if (!this.vehicleData?.variantKey && !this.vehicleData?.rowKey) {
    this.toastr.error('Vehicle data missing. Please select vehicle again');
    console.error('❌ vehicleData:', this.vehicleData);
    return;
  }

  // ✅ STEP 3: Prepare items
  const items = this.noPartsNames.map(name => ({
    partNumber: null,
    quoteLineItemId: 0,
    partName: name,
    quantity: 1,
    partType: null,
    brandName: null,
    mrp: 0,
    discount: 0,
    vendorId: 0,
    deliveryTime: null,
    availableStock: null,
    sellingPrice: 0,
    inputName: name
  }));

  const requestBody: any = {
    garageKey: localStorage.getItem("garageKey"),
    wrongPartNames: this.noPartsNames.join(', '),

    variantKey: this.vehicleData.variantKey,
    rowKey: this.vehicleData.rowKey,

    "userType": "pitstopspare",
    requestType: "web",
    spareGarageId: localStorage.getItem("merchantId"),

    regNo: (
      this.vehicleData?.registrationNumber ||
      localStorage.getItem('registrationNumber') ||
      localStorage.getItem('carNumber') ||
      ''
    ).replace(/["\s]/g, ''),

    manufacturingYear: this.vehicleData.year,
    variant: this.vehicleData.variant,

    // 🔥 FIXED
    fuelType: this.vehicleData.fuel || this.vehicleData.fuelType,
    make: this.vehicleData.make,
    model: this.vehicleData.model,

    vinNo: this.vehicleData.vin,

    items: items,
    userKey: localStorage.getItem('spareUserKey') || '',
    kitFlow: true,
    kitType:'clutchKit'
  };

  // console.log('📤 FINAL REQUEST BODY:', requestBody);

  // ✅ STEP 5: API
  this.aspLoadingService.show();

  this.clutchKitService.createQuotation(requestBody)
    .subscribe({
      next: (response: any) => {
        this.aspLoadingService.hide();

        // ✅ SUCCESS CASE
      if (response?.code === 200) {

          this.spareRequestId = response?.data?.requestId;

          // 🔥 THIS IS MISSING
          this.updatePopupData = {
            requestId: response?.data?.requestId,
            requestCreatedAt: response?.data?.requestCreatedAt
              ? new Date(response.data.requestCreatedAt.replace(' ', 'T'))
              : new Date()
          };

          // console.log("✅ Recreated Request Data:", this.updatePopupData);

          this.isRequestExistsPopupOpen = false;

          setTimeout(() => {
            this.isPopupOpen = true;
            this.cd.detectChanges();
          }, 0);
        }
        else if (response?.code === 1103) {

          // console.log('⚠️ Request already exists');

          // ✅ Extract request ID from error message
          const msg = response?.data?.description || '';
          const match = msg.match(/\d+/); // extract number
          const existingId = match ? match[0] : null;

          if (existingId) {
            this.existingRequestId = existingId;

            // ✅ ALWAYS TRUE
            this.reCreateRequest = true;

            // ✅ Call existing API
            this.checkExistingRequest();
          } else {
            this.toastr.error('Unable to fetch existing request ID');
          }
        }

        else {
          this.toastr.error(response?.data?.description || 'Failed to create request');
        }
      },

      error: (err) => {
        this.aspLoadingService.hide();
        console.error('❌ Error:', err);
      }
    });
  }
  goToRequestDetails() {
    if (!this.spareRequestId) return;

    this.router.navigate(['/request-details'], {
      queryParams: { id: this.spareRequestId }
    });

  }
  clearVehicleData() {
    localStorage.removeItem('vehicleData');
    localStorage.removeItem('registrationNumber');
    localStorage.removeItem('rowKey');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('variant');
  }
  checkExistingRequest() {
    const spareGarageId = localStorage.getItem('merchantId');

    if (!spareGarageId || !this.existingRequestId) {
      console.warn('Missing spareGarageId or requestId');
      return;
    }

    this.aspLoadingService.show();

    this.clutchKitService
      .getSpareRequest('pitstopSpare', spareGarageId, this.existingRequestId)
      .subscribe({
        next: (response: any) => {
          // console.log("response==============", response);

          if (response) {
            this.existingRequest = response;

            // ✅ IMPORTANT: DIRECTLY HIT QUOTATION AGAIN
            this.reCreateQuotation();
          } else {
            this.aspLoadingService.hide();
            this.toastr.error(response?.message || 'Something went wrong.');
          }
        },
        error: (err) => {
          this.aspLoadingService.hide();
          console.error('API Error:', err);
          this.toastr.error('Failed to fetch request details.');
        },
      });
  }
  reCreateQuotation() {

    // ❌ DO NOT USE existingRequest items at all

    const items = this.noPartsNames.map(name => ({
      partNumber: null,
      quoteLineItemId: 0,
      partName: name,
      quantity: 1,
      partType: null,
      brandName: null,
      mrp: 0,
      discount: 0,
      vendorId: 0,
      deliveryTime: null,
      availableStock: null,
      sellingPrice: 0,
      inputName: name
    }));

    const requestBody: any = {
      garageKey: localStorage.getItem("garageKey"),
      wrongPartNames: this.noPartsNames.join(', '),

      variantKey: this.vehicleData.variantKey,
      rowKey: this.vehicleData.rowKey,

      userType: "pitstopspare",
      requestType: "web",
      spareGarageId: localStorage.getItem("merchantId"),

      regNo: (
        this.vehicleData?.registrationNumber ||
        localStorage.getItem('registrationNumber') ||
        ''
      ).replace(/["\s]/g, ''),

      manufacturingYear: this.vehicleData.year,
      variant: this.vehicleData.variant,

      fuelType: this.vehicleData.fuel || this.vehicleData.fuelType,
      make: this.vehicleData.make,
      model: this.vehicleData.model,
      vinNo: this.vehicleData.vin,
      items: items,   // 🔥 THIS NOW USES 111 API DATA
      userKey: localStorage.getItem('spareUserKey') || '',
       kitFlow: true,
       kitType: 'clutchKit',
      reCreateRequest: true
    };

    // console.log("🔥 Recreate Request Body:", requestBody);

    this.aspLoadingService.show();

    this.clutchKitService.createQuotation(requestBody)
      .subscribe({
        next: (response: any) => {
          this.aspLoadingService.hide();

         if (response?.code === 200) {

  this.spareRequestId = response?.data?.requestId;

  // 🔥 THIS IS THE MISSING PIECE
  this.updatePopupData = {
    requestId: response?.data?.requestId,
    requestCreatedAt: response?.data?.requestCreatedAt
      ? new Date(response.data.requestCreatedAt.replace(' ', 'T'))
      : new Date()
  };

  // console.log("✅ Recreated Request Data:", this.updatePopupData);

  this.isRequestExistsPopupOpen = false;

  setTimeout(() => {
    this.isPopupOpen = true;
    this.cd.detectChanges();
  }, 0);
}
          else {
            this.toastr.error(response?.data?.description || 'Failed to recreate request');
          }
        },
        error: (err) => {
          this.aspLoadingService.hide();
          console.error("❌ Recreate error:", err);
        }
      });
  }
  formatTitle(title: string): string {
    if (!title) return '';

    return title
      .split(',')
      .map(part => {
        part = part.trim();

        // Capitalize each word
        part = part.replace(/\b\w/g, c => c.toUpperCase());

        // Add space before (
        part = part.replace(/\(/g, ' (');

        // Fix + spacing
        part = part.replace(/\+/g, ' + ');

        // Clean extra spaces
        part = part.replace(/\s+/g, ' ').trim();

        return part;
      })
      .join(', '); // ✅ KEEP COMMA
  }
  hitFailureAPI() {

    const vehicleData = JSON.parse(localStorage.getItem('vehicleData') || '{}');

    const payload = {
      registrationNumber: (localStorage.getItem('registrationNumber') || '').replace(/\s/g, ''),
      make: localStorage.getItem('selectedMake') || vehicleData?.make || '',
      model: localStorage.getItem('selectedModel') || vehicleData?.model || '',
      variant: localStorage.getItem('variant') || vehicleData?.variant || '',
      userKey: localStorage.getItem('spareUserKey') || vehicleData?.userKey || '',
      garageKey: localStorage.getItem('garageKey') || vehicleData?.garageKey || '',
      sourceType: localStorage.getItem('source') || '', 
      failureType: 'No Result',
      status: 1,

      garageName: localStorage.getItem('spareSelectedGarageName') || '',
      userMobile: localStorage.getItem('contactPhone') || '',
      userRole: localStorage.getItem('roleType') || '',
      userName: localStorage.getItem('contactName') || '',
    };
    // console.log('🚨 Failure API Payload:', payload);
    this.clutchKitService.createKitSearchFailure(payload)
      .subscribe({
        next: (res: any) => console.log('✅ Failure API success:', res),
        error: (err) => console.error('❌ Failure API error:', err)
      });
  }
  setClutchTexts() {

    this.brandText = [...new Set(
      this.clutchList
        ?.map(item => item?.brand)
        ?.filter(value => value)
    )].join(', ');

    this.partNumberText = this.clutchList
      ?.map(item => item?.partNumber)
      ?.filter(value => value)
      ?.join(', ');

    this.partTypeText = [...new Set(
      this.clutchList
        ?.map(item => item?.partType)
        ?.filter(value => value)
    )].join(', ');
  }
  selectKit(type: string): void {
    this.selectedKitType = type;
    if (type === 'OES') {
      this.filteredClutchList = this.oesItem?.items || [];
      this.pricingSummary = {
        title: this.oesItem?.title,
        totalMrp: this.oesItem?.totalMrp,
        totalSellingPrice: this.oesItem?.totalSellingPrice,
        discount: this.oesItem?.discount,
        savings: this.oesItem?.savings
      };
      this.selectedItem = {
        // partName: this.oesItem?.title,
         partName: this.oesItem?.items
    ?.map(x => x.partName)
    ?.filter(Boolean)
    ?.join(' + '),

        mrp: this.oesItem?.totalMrp,
        sellingPrice: this.oesItem?.totalSellingPrice,
        saveAmount: this.oesItem?.savings,
        discount: this.oesItem?.discount,
        items: this.oesItem?.items
      };
    } else {
      this.filteredClutchList = this.oemItem?.items || [];
      this.pricingSummary = {
        title: this.oemItem?.title,
        totalMrp: this.oemItem?.totalMrp,
        totalSellingPrice: this.oemItem?.totalSellingPrice,
        discount: this.oemItem?.discount,
        savings: this.oemItem?.savings
      };
      this.selectedItem = {
        // partName: this.oemItem?.title,
        partName: this.oemItem?.items
    ?.map(x => x.partName)
    ?.filter(Boolean)
    ?.join(' + '),
        mrp: this.oemItem?.totalMrp,
        sellingPrice: this.oemItem?.totalSellingPrice,
        saveAmount: this.oemItem?.savings,
        discount: this.oemItem?.discount,
        items: this.oemItem?.items
      };
    }
      const firstItem = this.selectedItem?.items?.[0];
      this.selectedImage = firstItem?.image || this.defaultImage;
      this.activeItem = firstItem;
  }
//  shareOnWhatsApp() {
//     const hasOEM = this.oemParts?.length > 0;
//     const hasOES = this.oesParts?.length > 0;

//     const kitName =
//       this.oemItem?.title ||
//       this.oesItem?.title ||
//       this.summaryTitle ||
//       'Clutch Kit';

//     const quoteUrl = window.location.href;

//     // ✅ CORRECT SAVINGS CALCULATION
//     const extraSavings =
//       (this.oemItem?.totalSellingPrice || 0) -
//       (this.oesItem?.totalSellingPrice || 0);

//     // ✅ PART FORMATTER
//     const formatParts = (parts: any[]) => {
//       return parts.map((part: any) => `
//   🔧 *${part?.partName || '-'}*
//   ▫️ Brand: ${part?.brand || '-'}
//   💰 MRP: ₹${part?.mrp || 0}
//   `).join('\n');
//     };

//     let message = '';

//     // ✅ BOTH OEM + OES
//     if (hasOEM && hasOES) {

//       message = `🚘 *Autoverse Clutch Kit Quote*
//   For: *${this.vehicleData?.make || ''} ${this.vehicleData?.model || ''}*

//   🔵 *OEM Option*

//   ${formatParts(this.oemParts)}

//   ✅ Genuine OEM Parts
//   🚚 Dispatch: 15 mins

//   ⭐ *SMART VALUE OPTION* (Recommended)

//   ${formatParts(this.oesParts)}

//   🔥 *SAVE ₹${extraSavings} MORE vs OEM*

//   🚚 Dispatch: 15 mins
//   ✔ Trusted Fitment
//   ✔ Warranty Available

//   💡 *Why many garages choose OES*
//   ✔ Better profits
//   ✔ Same fitment compatibility

// 📲 *Reply with:*
// ▫️ 1️⃣ OEM
// ▫️ 2️⃣ OES

//   🔗 *Compare Both Options:*
//   ${quoteUrl}

//   Tap to view full comparison`;
//     }

//     // ✅ ONLY OEM
//     else if (hasOEM) {

//       message = `🚘 *Autoverse Clutch Kit Quote*
//   For: *${this.vehicleData?.make || ''} ${this.vehicleData?.model || ''}*

//   🔵 *OEM Option*

//   ${formatParts(this.oemParts)}

//   ✅ Genuine OEM Parts
//   🚚 Dispatch: 15 mins

//   📲 *Reply CONFIRM to place the order.*

//   🔗 *View Approved Quote here:*
//   ${quoteUrl}`;
//     }

//     // ✅ ONLY OES
//     else if (hasOES) {

//       message = `🚘 *Autoverse Clutch Kit Quote*
//   For: *${this.vehicleData?.make || ''} ${this.vehicleData?.model || ''}*

//   ⭐ *SMART VALUE OPTION* (Recommended)

//   ${formatParts(this.oesParts)}

//   🚚 Dispatch: 15 mins
//   ✔ Trusted Fitment
//   ✔ Warranty Available

//   📲 *Reply CONFIRM to place the order.*

//   🔗 *View Approved Quote here:*
//   ${quoteUrl}`;
//     }

//     const whatsappUrl =
//       `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;

//     window.open(whatsappUrl, '_blank');

//     this.aspLoadingService.hide();
//   }
  shareOnWhatsApp() {

    const hasOEM = this.oemParts?.length > 0;
    const hasOES = this.oesParts?.length > 0;

    const quoteUrl = window.location.href;

    // ✅ Savings Calculation
    const extraSavings =
      (this.oemItem?.totalSellingPrice || 0) -
      (this.oesItem?.totalSellingPrice || 0);

    // ✅ PART FORMATTER
    const formatParts = (parts: any[]) => {

      return parts.map((part: any) =>
  `🔧 *${part?.partName || '-'}*
  🏷️ Brand: *${part?.brand || '-'}*
  🏁 MRP: *₹${part?.sellingPrice || 0}*`
      ).join('\n\n');
    };

    let message = '';

    // ✅ BOTH OEM + OES
    if (hasOEM && hasOES) {

message = `🚘 *Autoverse Clutch Kit Quote*

🔧 *${this.summaryTitle || 'Clutch Kit'}* Quote is Ready

Compare both options and choose what works best for your garage 👇

━━━━━━━━━━━━━━━

  🔵 *OEM OPTION*

  ${formatParts(this.oemParts)}

  💵 *Total: ₹${this.oemItem?.totalSellingPrice || 0}*

  ✅ Genuine OEM Parts
  ⚡ Dispatches in 15 mins

  ━━━━━━━━━━━━━━━

  🟩 *OES OPTION (Recommended ⭐)*

  ${formatParts(this.oesParts)}

  💵 *Total: ₹${this.oesItem?.totalSellingPrice || 0}*
  ${extraSavings > 0 ? `\n🔥 SAVE ₹${extraSavings} MORE vs OEM` : ''}

  ⭐ Why many garages choose OES
  💸 Better profits
  ✅ Trusted Quality
  ⚡ Dispatches in 15 mins
  ✔ Better value for customers

  ━━━━━━━━━━━━━━━

  📲 *Reply with:*
      1️⃣ OEM\n
      2️⃣ OES

    to confirm your order.`;
    }

    // ✅ ONLY OEM
    // ✅ ONLY OEM
    else if (hasOEM) {

      message = `🔧 *${this.oemItem?.title || 'Clutch Kit'} Quote is Ready*

    🟦 *OEM Option*

    ${formatParts(this.oemParts)}

    💵 *Total: ₹${this.oemItem?.totalSellingPrice || 0}*

    ✅ Genuine OEM Parts
    ⚡ Dispatches in 15 mins

    📲 Reply CONFIRM to place the order.`;
    }
    // ✅ ONLY OES
    else if (hasOES) {

      message = `🔧 *${this.oesItem?.title || 'Clutch Kit'}* Quote is Ready

    🟩 *OES Option (Recommended ⭐)*

    ${formatParts(this.oesParts)}

    💵 *Total: ₹${this.oesItem?.totalSellingPrice || 0}*

    💸 Better Margins
    ✅ Trusted Quality
    ⚡ Dispatches in 15 mins

    📲 Reply CONFIRM to place the order.`;
    }

    const whatsappUrl =
      `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, '_blank');

    this.aspLoadingService.hide();
  }
  hasSameBrand(items: any[]): boolean {

    if (!items || items.length === 0) {
      return false;
    }

    const brands = items
      .map(item => item?.brand?.trim()?.toLowerCase())
      .filter(Boolean);

    return new Set(brands).size === 1;
  }
}